module.exports = __webpack_public_path__ + "media/images/blog_comment_icon-01d3b7c9aa08b261c2d0af7529258e64.png";